export let MatchAction;(function(t){t["ALL"]="All";t["ANY"]="Any";t["ONE"]="One"})(MatchAction||(MatchAction={}));